import React from 'react';

import './index.css';

type ToggleSwitchProps = {
    className?: string;
    onClassName?: string;
    offClassName?: string;
    label?: string;
    toggle: boolean;
    onClick: () => void;
};

function ToggleSwitch({
    className,
    onClassName,
    offClassName,
    label,
    toggle,
    onClick
} : ToggleSwitchProps) {
    return (
        <div className={`toggleSwitch ${className}`}>
            <p className='toggleSwitch__label'>{label}</p>
            <div
                className={toggle
                    ? `toggleSwitch--on ${onClassName}`
                    : `toggleSwitch--off ${offClassName}`
                }
                onClick={onClick}
            >
                <div className='toggleSwitch__switch'></div>
            </div>
        </div>
    );
}

export default ToggleSwitch;